import {
  get,
  post,
  put,
  del,
} from '@/utils/request';

const url = 'office-monthly-reports';

export function index(data) {
  return get({
    url,
    data,
  });
}

export function getStoreIncomes(report_date) {
  return get({
    url: `${url}/store-incomes`,
    data: { report_date },
  });
}

export function getStoreIncomesByReportId(id) {
  return get({
    url: `${url}/${id}/store-incomes`,
  });
}

export function getStaffSalariesByReportId(id) {
  return get({
    url: `${url}/${id}/staff-salaries`,
  });
}

export function show(id) {
  return get({
    url: `${url}/${id}`,
  });
}

export function store(data) {
  return post({
    url,
    data,
  });
}

export function update(id, data) {
  return put({
    url: `${url}/${id}`,
    data,
  });
}

export function destroy(id) {
  return del({
    url: `${url}/${id}`,
  });
}
